<template>
  <v-flex>
    <v-card color="white" class="rounded">
      <v-card-title class="mb-0">
        <h4 class="subheading ml-1">Bounty List</h4>
        <v-spacer></v-spacer>
        <v-flex style="flex-grow: 0">
          <v-select
            class="width-max-120px"
            dense
            outline
            single-line
            :items="yearList"
            v-model="selectedYear"
            label="Year"
            @change="changeYear"
            hide-details
          ></v-select>
        </v-flex>
        <v-flex ml-2 style="flex-grow: 0">
          <v-select
            class="width-max-120px"
            dense
            outline
            single-line
            :items="monthList"
            v-model="selectedMonth"
            label="Month"
            @change="changeMonth"
            hide-details
          ></v-select>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex>
          <v-select
            class="width-max-120px"
            dense
            outline
            single-line
            :items="bountyFilters"
            v-model="selectedBountyFilter"
            label="Filter"
            @change="changeBountyFilter"
            hide-details
          ></v-select>
        </v-flex>
        <v-flex>
          <v-text-field
            v-model="bountyListSearch"
            append-icon="search"
            label="Search"
            single-line
            outline
            hide-details
          ></v-text-field>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex text-xs-right>
          <v-btn
            small
            color="#d13b55"
            class="btn-rounded-medium white--text"
            @click.prevent="showCreateBounty"
            :disabled="bountyLoading"
            >Create Bounty</v-btn
          >
        </v-flex>
      </v-card-title>
      <v-card-text class="pt-0">
        <div>
          <v-data-table
            :headers="bountyListHeaders"
            :items="bountyList"
            :loading="bountyLoading"
            :search="bountyListSearch"
            item-key="id"
            sort-by="startDate"
            hide-actions
            class="elevation-1"
          >
            <template v-slot:progress>
              <v-progress-linear
                color="#d13b55"
                height="2"
                indeterminate
              ></v-progress-linear>
            </template>
            <template v-slot:items="props">
              <td>
                <a href="#" @click.prevent="showBountyDetails(props.item)">{{
                  props.item.title
                }}</a>
              </td>
              <td>
                {{ props.item.ovations }}
              </td>
              <td>
                {{ props.item.createdByName }}
              </td>
              <td>
                <div v-html="getBountyStatus(props.item)"></div>
              </td>
              <td>
                {{ props.item.startDate | moment("MM/DD/YYYY") }}
              </td>
              <td>
                {{ props.item.endDate | moment("MM/DD/YYYY") }}
              </td>
              <td>
                <div class="d-flex">
                  <div
                    v-if="
                      $store.getters.getUserIdentifier ===
                        props.item.createdById && $store.getters.isCurrentOrgSet
                    "
                  >
                    <v-btn
                      icon
                      small
                      title="Edit Bounty"
                      @click.stop="showEditBounty(props.item)"
                      v-if="props.item.signupUsersList.length == 0"
                    >
                      <v-icon color="secondary">mdi-pencil mdi-18px</v-icon>
                    </v-btn>
                  </div>

                  <div
                    v-if="
                      $store.getters.getUserIdentifier ===
                        props.item.createdById && $store.getters.isCurrentOrgSet
                    "
                  >
                    <v-btn
                      icon
                      small
                      title="Delete Bounty"
                      @click.stop="showDeleteBounty(props.item)"
                      v-if="props.item.signupUsersList.length == 0"
                    >
                      <v-icon color="secondary">mdi-delete mdi-18px</v-icon>
                    </v-btn>
                  </div>

                  <div
                    class="ml-4"
                    v-if="
                      $store.getters.getUserIdentifier !=
                        props.item.createdById &&
                      props.item.open &&
                      props.item.completed === false &&
                      props.item.expired === false &&
                      props.item.cancelled === false
                    "
                  >
                    <v-btn
                      icon
                      small
                      title="Signup for Bounty"
                      @click.stop="showUserStartBounty(props.item)"
                    >
                      <v-icon color="secondary">mdi-play</v-icon>
                    </v-btn>
                  </div>

                  <div
                    v-if="
                      $store.getters.getUserIdentifier ===
                        props.item.createdById && $store.getters.isCurrentOrgSet
                    "
                  >
                    <v-btn
                      icon
                      small
                      title="Complete Bounty"
                      @click.stop="showCompleteBounty(props.item)"
                      v-if="
                        props.item.signupUsersList.length > 0 &&
                        props.item.completed === false &&
                        props.item.expired === false &&
                        props.item.cancelled === false
                      "
                    >
                      <v-icon color="secondary">mdi-check</v-icon>
                    </v-btn>
                  </div>

                  <div
                    v-if="
                      $store.getters.getUserIdentifier ===
                        props.item.createdById && $store.getters.isCurrentOrgSet
                    "
                  >
                    <v-btn
                      icon
                      small
                      title="Cancel user signup"
                      @click.stop="showCancelUserSignup(props.item)"
                      v-if="
                        props.item.signupUsersList.length > 0 &&
                        props.item.completed === false &&
                        props.item.expired === false &&
                        props.item.cancelled === false
                      "
                    >
                      <v-icon color="secondary">mdi-cancel mdi-18px</v-icon>
                    </v-btn>
                  </div>

                  <div
                    class="ml-4"
                    v-if="
                      $store.getters.getUserIdentifier ===
                        (props.item.signupUsersList.length > 0
                          ? props.item.signupUsersList[0].id
                          : '') &&
                      props.item.signupUsersList.length > 0 &&
                      props.item.open === false &&
                      props.item.completed === false &&
                      props.item.expired === false &&
                      props.item.cancelled === false
                    "
                  >
                    <v-btn
                      icon
                      small
                      title="Signout from Bounty"
                      @click.stop="showUserStopBounty(props.item)"
                    >
                      <v-icon color="secondary">mdi-stop</v-icon>
                    </v-btn>
                  </div>
                </div>
              </td>
            </template>
          </v-data-table>
        </div>
      </v-card-text>
    </v-card>

    <v-dialog
      v-model="showCreateBountyDialog"
      max-width="600"
      overlay
      persistent
    >
      <CreateBounty
        v-if="editBountyItem == null"
        @close="hideCreateBounty"
      ></CreateBounty>
    </v-dialog>

    <v-dialog v-model="showEditBountyDialog" max-width="600" overlay persistent>
      <CreateBounty
        v-if="editBountyItem && showEditBountyDialog"
        @close="hideCreateBounty"
        v-bind:bounty-item="editBountyItem"
      ></CreateBounty>
    </v-dialog>

    <v-dialog
      v-model="showDeleteBountyDialog"
      max-width="400"
      overlay
      persistent
    >
      <v-card v-if="deleteBountyItem" color="white" class="rounded">
        <v-card-title class="mb-0">
          <h4 class="subheading font-weight-medium">Delete Bounty?</h4>
        </v-card-title>
        <v-card-text class="pt-0">
          <div v-if="deleteBountyItem.signupUsersList.length == 0">
            Are you sure to delete
            <strong>'{{ deleteBountyItem.title }}'</strong> Bounty?
          </div>
          <p
            class="red--text text--lighten-1"
            v-if="deleteBountyItem.signupUsersList.length > 0"
          >
            {{ deleteBountyItem.signupUsersList.length }} user(s) already signed
            up for '{{ deleteBountyItem.title }}' bounty, you can't delete it.
          </p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            flat
            :disabled="bountyDeleteLoading"
            @click.prevent="hideDeleteBounty"
            >Cancel</v-btn
          >
          <v-btn
            color="red"
            flat
            :loading="bountyDeleteLoading"
            @click.prevent="deleteBounty"
            :disabled="deleteBountyItem.signupUsersList.length > 0"
            >Delete</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showStartBountyDialog"
      max-width="600"
      overlay
      persistent
    >
      <v-card v-if="startBountyItem" color="white" class="rounded">
        <v-card-title class="mb-0">
          <h4 class="subheading font-weight-medium">Signup for Bounty?</h4>
        </v-card-title>
        <v-card-text class="pt-0">
          <div>
            Are you sure to signup for the
            <strong>'{{ startBountyItem.title }}'</strong> Bounty?
          </div>
          <div class="mt-2 mb-2">
            <div class="font-weight-bold">Description:</div>
            <div
              class="rounded"
              style="
                height: 200px;
                overflow: auto;
                border: 1px solid #efefef;
                padding: 10px;
              "
              v-html="startBountyItem.description"
            ></div>
          </div>

          <div
            class="mb-2"
            v-if="
              startBountyItem.fileUrl != null && startBountyItem.fileUrl != ''
            "
          >
            <a :href="startBountyItem.fileUrl" target="_blank"
              >View attachment</a
            >
          </div>

          <div class="mb-2">
            <div>
              <span class="font-weight-bold">Ovations:</span>
              {{ startBountyItem.ovations }}
            </div>
          </div>

          <div>
            <span class="font-weight-bold">Start:</span>
            <span class="mx-2">{{
              startBountyItem.startDate | moment("MM/DD/YYYY")
            }}</span>
            <span class="font-weight-bold">End:</span>
            <span class="ml-2">{{
              startBountyItem.endDate | moment("MM/DD/YYYY")
            }}</span>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            flat
            :disabled="bountySignupLoading"
            @click.prevent="hideStartBounty"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            flat
            :loading="bountySignupLoading"
            @click.prevent="startBounty"
            >Signup</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showStopBountyDialog" max-width="400" overlay persistent>
      <v-card v-if="stopBountyItem" color="white" class="rounded">
        <v-card-title class="mb-0">
          <h4 class="subheading font-weight-medium">Signout from Bounty?</h4>
        </v-card-title>
        <v-card-text class="pt-0">
          <div>
            Are you sure to signout from the
            <strong>'{{ stopBountyItem.title }}'</strong> Bounty that will award
            you <strong>'{{ stopBountyItem.ovations }}'</strong> Ovations when
            completed?
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            flat
            :disabled="bountySignoutLoading"
            @click.prevent="hideStopBounty"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            flat
            :loading="bountySignoutLoading"
            @click.prevent="stopBounty"
            >Signout</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showCompleteBountyDialog"
      max-width="400"
      overlay
      persistent
    >
      <v-card v-if="completeBountyItem" color="white" class="rounded">
        <v-card-title class="mb-0">
          <h4 class="subheading font-weight-medium">Complete Bounty?</h4>
        </v-card-title>
        <v-card-text class="pt-0">
          <div>
            Are you sure to set status as complete for the
            <strong>'{{ completeBountyItem.title }}'</strong> Bounty and award
            <strong>'{{ completeBountyItem.ovations }}'</strong> Ovations to the
            following member?
          </div>
          <div
            class="mt-4"
            v-if="completeBountyItem.signupUsersList.length > 0"
          >
            <v-avatar :size="28" class="mr-2" color="grey lighten-4">
              <img
                :src="completeBountyItem.signupUsersList[0].avatar"
                :alt="completeBountyItem.signupUsersList[0].name"
              />
            </v-avatar>
            {{ completeBountyItem.signupUsersList[0].name }}
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            flat
            :disabled="bountyCompleteLoading"
            @click.prevent="hideCompleteBounty"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            flat
            :loading="bountyCompleteLoading"
            @click.prevent="completeBounty"
            >Ok</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showCancelUserSignupBountyDialog"
      max-width="400"
      overlay
      persistent
    >
      <v-card v-if="cancelUserSignupBountyItem" color="white" class="rounded">
        <v-card-title class="mb-0">
          <h4 class="subheading font-weight-medium">
            Cancel member signup from Bounty?
          </h4>
        </v-card-title>
        <v-card-text class="pt-0">
          <div>
            Are you sure to cancel member signup from the
            <strong>'{{ cancelUserSignupBountyItem.title }}'</strong> Bounty
            that will award
            <strong>'{{ cancelUserSignupBountyItem.ovations }}'</strong>
            Ovations to the following member?
          </div>
          <div
            class="mt-4"
            v-if="cancelUserSignupBountyItem.signupUsersList.length > 0"
          >
            <v-avatar :size="28" class="mr-2" color="grey lighten-4">
              <img
                :src="cancelUserSignupBountyItem.signupUsersList[0].avatar"
                :alt="cancelUserSignupBountyItem.signupUsersList[0].name"
              />
            </v-avatar>
            {{ cancelUserSignupBountyItem.signupUsersList[0].name }}
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            flat
            :disabled="bountyCancelUserSignupLoading"
            @click.prevent="hideCancelUserSignupBounty"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            flat
            :loading="bountyCancelUserSignupLoading"
            @click.prevent="cancelUserSignupBounty"
            >Ok</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showBountyDetailsDialog"
      max-width="600"
      overlay
      persistent
    >
      <v-card v-if="bountyDetailsItem" color="white" class="rounded">
        <v-card-title class="mb-0">
          <h4 class="subheading font-weight-medium">Bounty Details</h4>
        </v-card-title>
        <v-card-text class="pt-0">
          <div>
            <span class="font-weight-bold">Title:</span> '{{
              bountyDetailsItem.title
            }}'
          </div>

          <div class="mt-2 mb-2">
            <div class="font-weight-bold">Description:</div>
            <div
              class="rounded"
              style="
                height: 200px;
                overflow: auto;
                border: 1px solid #efefef;
                padding: 10px;
              "
              v-html="bountyDetailsItem.description"
            ></div>
          </div>

          <div
            class="mb-2"
            v-if="
              bountyDetailsItem.fileUrl != null &&
              bountyDetailsItem.fileUrl != ''
            "
          >
            <a :href="bountyDetailsItem.fileUrl" target="_blank"
              >View attachment</a
            >
          </div>

          <div class="mb-2">
            <div>
              <span class="font-weight-bold">Ovations:</span>
              {{ bountyDetailsItem.ovations }}
            </div>
          </div>

          <div>
            <span class="font-weight-bold">Start:</span>
            <span class="mx-2">{{
              bountyDetailsItem.startDate | moment("MM/DD/YYYY")
            }}</span>
            <span class="font-weight-bold">End:</span>
            <span class="ml-2">{{
              bountyDetailsItem.endDate | moment("MM/DD/YYYY")
            }}</span>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" flat @click.prevent="hideBountyDetails"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-flex>
</template>

<script>
import axios from "axios";
import CreateBounty from "@/components/CreateBounty";

export default {
  name: "BountyList",
  components: { CreateBounty },
  data() {
    return {
      bountyLoading: true,
      bountyDeleteLoading: false,
      bountySignupLoading: false,
      bountyCompleteLoading: false,
      bountySignoutLoading: false,
      bountyCancelUserSignupLoading: false,
      bountyList: [],
      yearList: [
        (new Date().getFullYear() - 1).toString(),
        new Date().getFullYear().toString(),
      ],
      selectedYear: new Date().getFullYear().toString(),
      monthList: [
        { text: "---", value: "-1" },
        { text: "Jan", value: "1" },
        { text: "Feb", value: "2" },
        { text: "Mar", value: "3" },
        { text: "Apr", value: "4" },
        { text: "May", value: "5" },
        { text: "Jun", value: "6" },
        { text: "Jul", value: "7" },
        { text: "Aug", value: "8" },
        { text: "Sep", value: "9" },
        { text: "Oct", value: "10" },
        { text: "Nov", value: "11" },
        { text: "Dec", value: "12" },
      ],
      selectedMonth: "-1",
      bountyFilters: [
        { text: "All", value: "all" },
        { text: "Open", value: "open" },
        { text: "In-Prog", value: "inprogress" },
        { text: "Completed", value: "completed" },
      ],
      selectedBountyFilter: "open",
      bountyListSearch: "",
      bountyListHeaders: [
        { text: "Title", value: "title", class: "subheading" },
        { text: "Ovations", value: "ovations", class: "subheading" },
        { text: "Owner", value: "createdByName", class: "subheading" },
        { text: "Status", value: "id", class: "subheading" },
        { text: "Start", value: "startDate", class: "subheading" },
        { text: "End", value: "endDate", class: "subheading" },
        {
          text: "Action",
          value: "id",
          sortable: false,
          align: "center",
          class: "subheading",
        },
      ],
      showCreateBountyDialog: false,
      showEditBountyDialog: false,
      showDeleteBountyDialog: false,
      showStartBountyDialog: false,
      showCompleteBountyDialog: false,
      showStopBountyDialog: false,
      showCancelUserSignupBountyDialog: false,
      showBountyDetailsDialog: false,
      editBountyItem: null,
      deleteBountyItem: null,
      startBountyItem: null,
      completeBountyItem: null,
      stopBountyItem: null,
      cancelUserSignupBountyItem: null,
      bountyDetailsItem: null,
    };
  },
  methods: {
    getBountyList() {
      this.bountyList = [];
      this.bountyLoading = true;

      axios
        .get(
          "/api/bounty/list/" +
            this.$store.getters.getParentOrgIdentifier +
            "/" +
            this.selectedYear +
            "/" +
            this.selectedMonth +
            "/" +
            this.selectedBountyFilter,
          this.$store.state.axiosConfig
        )
        .then((response) => {
          this.bountyList = response.data;
          this.bountyLoading = false;
        })
        .catch((e) => {
          // check/ handle 401 (Unauthorized) error
          this.$store.dispatch("error401Response", e);

          // Display Error Message
          this.$store.commit("replaceSnackbar", {
            message:
              "Error. Could not retrieved Bounty list.<br>Response: " +
              e.response.data.message,
            messageType: "error",
          });

          this.bountyLoading = false;
        });
    },
    getBountyStatus(bountyItem) {
      var status = "--";
      if (
        bountyItem.signupUsersList.length > 0 &&
        bountyItem.completed === false &&
        bountyItem.expired === false &&
        bountyItem.cancelled === false
      ) {
        status = "<strong class='orange--text'>In progress</strong>";
      } else if (
        bountyItem.completed &&
        bountyItem.open === false &&
        bountyItem.expired === false &&
        bountyItem.cancelled === false
      ) {
        status = "<strong class='green--text'>Completed</strong>";
      } else if (bountyItem.cancelled) {
        status =
          "<strong class='grey--text text--lighten-1'>Cancelled</strong>";
      } else if (bountyItem.expired && bountyItem.signupUsersList.length == 0) {
        status = "<strong class='red--text text--lighten-1'>Expired</strong>";
      } else if (
        bountyItem.open &&
        bountyItem.expired === false &&
        bountyItem.cancelled === false &&
        bountyItem.completed === false
      ) {
        status = "<strong class='grey--text'>Open</strong>";
      }

      return status;
    },
    deleteBounty() {
      if (
        this.deleteBountyItem &&
        this.deleteBountyItem.signupUsersList.length > 0
      ) {
        this.$store.commit("replaceSnackbar", {
          message:
            "Cannot delete Bounty. There are users who have signed up for this Bounty.",
          messageType: "warning",
        });
        return;
      }

      this.bountyDeleteLoading = true;

      axios
        .post(
          "/api/bounty/delete/" +
            this.$store.getters.getParentOrgIdentifier +
            "/" +
            this.deleteBountyItem.createdById +
            "/" +
            this.deleteBountyItem.id,
          {},
          this.$store.state.axiosConfig
        )
        .then((response) => {
          // Refresh the Ovations balance
          if (response.data && response.data.userOvations) {
            if (
              response.data.ovationSource === "send_bucket" &&
              response.data.userOvations.unit === "giveOvation"
            ) {
              this.$store.state.userSelf.currentOrg.giveOvations =
                response.data.userOvations.amount;
            } else if (
              response.data.ovationSource === "redeem_share_bucket" &&
              response.data.userOvations.unit === "spendOvation"
            ) {
              this.$store.state.userSelf.currentOrg.spendOvations =
                response.data.userOvations.amount;
            }
          }

          this.bountyDeleteLoading = false;
          this.hideDeleteBounty();
          this.getBountyList();
          this.$store.commit("replaceSnackbar", {
            message: "Bounty has been deleted successfully",
          });
        })
        .catch((e) => {
          // check/ handle 401 (Unauthorized) error
          this.$store.dispatch("error401Response", e);

          // Display Error Message
          this.$store.commit("replaceSnackbar", {
            message:
              "Error while deleting bounty.<br><strong>" +
              e.response.data.message +
              "</strong>",
            messageType: "error",
          });

          this.bountyDeleteLoading = false;
        });
    },
    startBounty() {
      if (!this.startBountyItem) return;

      // Display loading message
      this.$store.commit("replaceSnackbar", {
        message: "Bounty signup in-progress...",
        messageType: "warning",
      });

      this.bountySignupLoading = true;

      const params = {
        id: this.startBountyItem.id,
        orgId: this.startBountyItem.orgId,
        OwnerId: this.startBountyItem.createdById,
        signupUserId: this.$store.getters.getUserIdentifier,
      };

      axios
        .post("/api/bounty/signup", params, this.$store.state.axiosConfig)
        .then((response) => {
          // Display Success message
          this.$store.commit("replaceSnackbar", {
            message: "Bounty signup succeeded",
          });

          this.bountySignupLoading = false;

          this.hideStartBounty();
          this.getBountyList();
        })
        .catch((e) => {
          // check/ handle 401 (Unauthorized) error
          this.$store.dispatch("error401Response", e);

          this.bountySignupLoading = false;

          // Display Error Message
          this.$store.commit("replaceSnackbar", {
            message:
              "Bounty signup failed.<br><strong>" +
              e.response.data.message +
              "</strong>",
            messageType: "error",
          });
        });
    },
    completeBounty: function () {
      if (!this.completeBountyItem) return;

      // Display loading message
      this.$store.commit("replaceSnackbar", {
        message: "Bounty complete in-progress...",
        messageType: "warning",
      });

      this.bountyCompleteLoading = true;

      const params = {
        id: this.completeBountyItem.id,
        orgId: this.completeBountyItem.orgId,
        OwnerId: this.completeBountyItem.createdById,
      };

      axios
        .post(
          "/api/bounty/signup/complete",
          params,
          this.$store.state.axiosConfig
        )
        .then((response) => {
          // Display Success message
          this.$store.commit("replaceSnackbar", {
            message: "Bounty completed successfully",
          });

          this.bountyCompleteLoading = false;

          this.hideCompleteBounty();
          this.getBountyList();
        })
        .catch((e) => {
          // check/ handle 401 (Unauthorized) error
          this.$store.dispatch("error401Response", e);

          this.bountyCompleteLoading = false;

          // Display Error Message
          this.$store.commit("replaceSnackbar", {
            message:
              "Bounty failed to complete.<br><strong>" +
              e.response.data.message +
              "</strong>",
            messageType: "error",
          });
        });
    },
    stopBounty: function () {
      if (!this.stopBountyItem) return;

      // Display loading message
      this.$store.commit("replaceSnackbar", {
        message: "Bounty signout in-progress...",
        messageType: "warning",
      });

      this.bountySignoutLoading = true;

      const params = {
        id: this.stopBountyItem.id,
        orgId: this.stopBountyItem.orgId,
        OwnerId: this.stopBountyItem.createdById,
        signoutUserId: this.$store.getters.getUserIdentifier,
      };

      axios
        .post("/api/bounty/signout", params, this.$store.state.axiosConfig)
        .then((response) => {
          // Display Success message
          this.$store.commit("replaceSnackbar", {
            message: "Bounty signout succeeded",
          });

          this.bountySignoutLoading = false;

          this.hideStopBounty();
          this.getBountyList();
        })
        .catch((e) => {
          // check/ handle 401 (Unauthorized) error
          this.$store.dispatch("error401Response", e);

          this.bountySignoutLoading = false;

          // Display Error Message
          this.$store.commit("replaceSnackbar", {
            message:
              "Bounty signout failed.<br><strong>" +
              e.response.data.message +
              "</strong>",
            messageType: "error",
          });
        });
    },
    cancelUserSignupBounty: function () {
      if (!this.cancelUserSignupBountyItem) return;

      // Display loading message
      this.$store.commit("replaceSnackbar", {
        message: "Bounty cancel signup in-progress...",
        messageType: "warning",
      });

      this.bountyCancelUserSignupLoading = true;

      const params = {
        id: this.cancelUserSignupBountyItem.id,
        orgId: this.cancelUserSignupBountyItem.orgId,
        OwnerId: this.$store.getters.getUserIdentifier,
      };

      axios
        .post(
          "/api/bounty/signup/cancel",
          params,
          this.$store.state.axiosConfig
        )
        .then((response) => {
          // Display Success message
          this.$store.commit("replaceSnackbar", {
            message: "Bounty signup cancelled successfully",
          });

          this.bountyCancelUserSignupLoading = false;

          this.hideCancelUserSignupBounty();
          this.getBountyList();
        })
        .catch((e) => {
          // check/ handle 401 (Unauthorized) error
          this.$store.dispatch("error401Response", e);

          this.bountyCancelUserSignupLoading = false;

          // Display Error Message
          this.$store.commit("replaceSnackbar", {
            message:
              "Bounty cancel signup failed.<br><strong>" +
              e.response.data.message +
              "</strong>",
            messageType: "error",
          });
        });
    },
    changeYear: function () {
      this.getBountyList();
    },
    changeMonth: function () {
      this.getBountyList();
    },
    changeBountyFilter: function () {
      this.getBountyList();
    },
    showCreateBounty: function () {
      this.showCreateBountyDialog = true;
    },
    hideCreateBounty: function (message) {
      this.showCreateBountyDialog = false;
      this.showEditBountyDialog = false;
      this.editBountyItem = null;
      if (message === "refresh") {
        this.getBountyList();
      }
    },
    hideDeleteBounty: function () {
      this.showDeleteBountyDialog = false;
      this.deleteBountyItem = null;
    },
    hideStartBounty: function (message) {
      this.showStartBountyDialog = false;
      this.startBountyItem = null;
    },
    hideCompleteBounty: function () {
      this.showCompleteBountyDialog = false;
      this.completeBountyItem = null;
    },
    hideStopBounty: function () {
      this.showStopBountyDialog = false;
      this.stopBountyItem = null;
    },
    hideCancelUserSignupBounty: function () {
      this.showCancelUserSignupBountyDialog = false;
      this.cancelUserSignupBountyItem = null;
    },
    hideBountyDetails: function () {
      this.showBountyDetailsDialog = false;
      this.bountyDetailsItem = null;
    },
    showEditBounty: function (bounty) {
      this.editBountyItem = bounty;
      this.showEditBountyDialog = true;
    },
    showDeleteBounty: function (bounty) {
      this.deleteBountyItem = bounty;
      this.showDeleteBountyDialog = true;
    },
    showUserStartBounty: function (bounty) {
      this.startBountyItem = bounty;
      this.showStartBountyDialog = true;
    },
    showCompleteBounty: function (bounty) {
      this.completeBountyItem = bounty;
      this.showCompleteBountyDialog = true;
    },
    showUserStopBounty: function (bounty) {
      this.stopBountyItem = bounty;
      this.showStopBountyDialog = true;
    },
    showCancelUserSignup: function (bounty) {
      this.cancelUserSignupBountyItem = bounty;
      this.showCancelUserSignupBountyDialog = true;
    },
    showBountyDetails: function (bounty) {
      // show edit dialog for owners
      if (this.$store.getters.getUserIdentifier === bounty.createdById) {
        this.showEditBounty(bounty);
      } else {
        // show details for everyone else
        this.bountyDetailsItem = bounty;
        this.showBountyDetailsDialog = true;
      }
    },
  },
  beforeMount() {
    this.getBountyList();
  },
};
</script>
